import { Analytics } from "analytics"
import TiktokPixel from "tiktok-pixel"

import isDevelopment from "@utils/isDevelopment"

interface TrackPayload {
    event: string
    properties: {}
}

interface IdentifyPayload {
    userId?: string
    traits?: {
        email: string
        phone_number: string
    }
}

const tiktokPixelPlugin = () => ({
    name: "tiktokPixel",
    config: {},
    initialize: async () => {
        TiktokPixel.init("CFRF3CBC77U8BC79HA3G", undefined, {
            debug: Boolean(isDevelopment)
        })
    },
    page: () => {
        TiktokPixel.pageView()
    },
    track: ({ payload }: { payload: TrackPayload }) => {
        TiktokPixel.track(payload.event, payload.properties)
    },
    identify: ({ payload }: { payload: IdentifyPayload }) => {
        window.ttq.identify({
            email: payload.traits?.email,
            phone_number: payload.traits?.phone_number
        })
    }
})

const tiktokPixelAnalytic = Analytics({
    app: "rekeningku-next-moengage",
    plugins: [tiktokPixelPlugin()]
})

export default tiktokPixelAnalytic
